module.exports = __webpack_public_path__ + "static/media/bg_banner_mobile.ac5bc893.png";